import { EmptyState } from "@/components";
import { useEnableContentMutation, useFetchDisabledDishesQuery } from "@/features/organizations/api/contentApi";
import { useAppSelector, useTerminology } from "@/hooks";
import useSnackbar from "@/hooks/useSnackbar";
import LoadingButton from "@mui/lab/LoadingButton";
import { CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";

const DisabledDishes = () => {
    const [openSnackbar] = useSnackbar();
    const { t } = useTerminology();
    const { organizationId } = useParams<{ organizationId?: string; }>();
    const activeBranch = useAppSelector((state) => state.ui.activeBranch);

    const { data, isLoading, refetch } = useFetchDisabledDishesQuery(
        organizationId ? { organizationId, activeBranch } : skipToken
    );

    const [enableDish, { isLoading: isMutating }] = useEnableContentMutation();

    const handleEnable = async (dishId: string) => {
        try {
            await enableDish({
                organizationId,
                contentId: dishId,
                activeBranch,
            }).unwrap();

            openSnackbar(t('product', 1, true) + ' habilitado!', 'success');
            refetch();
        } catch (error) {
            console.error("Mutation failed:", error);
            openSnackbar('Error al habilitar el ' + t('product') + '!', 'error');
        }
    };

    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Typography variant="overline" color="textSecondary">{t('product', 2, true)} deshabilitados</Typography>
                {isLoading ? (
                    <Stack alignItems="center" p={4}><CircularProgress /></Stack>
                ) : (
                    <Stack spacing={2}>
                        {data && data.length > 0 ? (
                            data.map((dish: any) => (
                                <Stack key={dish.id} direction="row" justifyContent="space-between" spacing={2}>
                                    <Typography>{dish.title}</Typography>
                                    <LoadingButton
                                        size="small"
                                        loading={isMutating}
                                        onClick={() => handleEnable(dish.id)}
                                    >
                                        Habilitar
                                    </LoadingButton>
                                </Stack>
                            ))
                        ) : (
                            <EmptyState
                                title="Nada de que preocuparse"
                                description={`No tienes ${t('product', 2)} deshabilitados`}
                            />
                        )}
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
};


export default DisabledDishes;
